import { __decorate, __extends } from "tslib";
import { inject, observer } from 'mobx-react';
import React from 'react';
import { deleteWound } from '../api/wounds';
import { customConfirm } from '../utils/utils';
import { getImageUrl } from '../api';
import { Button } from './Button';
import S from './WoundItem.styl';
var WoundItem = /** @class */ (function (_super) {
    __extends(WoundItem, _super);
    function WoundItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
        };
        _this.deleteItem = function () {
            var i18n = _this.props.store.i18n;
            var wound = _this.props.wound;
            if (wound) {
                customConfirm(i18n.woundsDeleteSummary, _this.props.store, function (success) {
                    if (success) {
                        _this.setState({ loading: true });
                        var request = {
                            id: wound.id,
                        };
                        deleteWound(request).then(function () {
                            _this.setState({ loading: false });
                            _this.isUpdated();
                        }).catch(function (error) {
                            _this.setState({ loading: false });
                            alert(error);
                        });
                    }
                });
            }
        };
        _this.isUpdated = function () {
            if (_this.props.isUpdated) {
                _this.props.isUpdated();
            }
        };
        _this.isEditClicked = function () {
            if (_this.props.isEditClicked) {
                _this.props.isEditClicked(_this.props.wound);
            }
        };
        return _this;
    }
    WoundItem.prototype.componentDidMount = function () {
        // Did Mount
    };
    WoundItem.prototype.render = function () {
        var props = this.props;
        var wound = props.wound;
        var i18n = props.store.i18n;
        return (React.createElement("div", { className: S.woundItem }, wound ?
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: S.tableCell + " imageCell" },
                    React.createElement("img", { src: getImageUrl(wound.image || '') })),
                React.createElement("div", { className: S.tableCell }, wound.title),
                React.createElement("div", { className: S.action },
                    React.createElement(Button, { className: S.updateButton, type: "button", onClick: this.isEditClicked }, i18n.actionUpdate),
                    React.createElement(Button, { className: S.deleteButton, type: "button", onClick: this.deleteItem }, i18n.actionDelete)))
            :
                React.createElement(React.Fragment, null)));
    };
    WoundItem = __decorate([
        inject('store'),
        observer
    ], WoundItem);
    return WoundItem;
}(React.Component));
export { WoundItem };
